var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"hotkey",rawName:"v-hotkey",value:(_vm.keymap),expression:"keymap"}]},[_vm._t("default",null,{"preselected":_vm.preselectedIndex})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }